import {
  Box,
  Drawer,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";

interface QrDrawerProps {
  open: boolean;
  onClose: () => void;
  link: string;
  code: string;
}

export function QrDrawer({ open, onClose, link, code }: QrDrawerProps) {
  const theme = useTheme();
  const { t } = useTranslation("referral");
  const dark = theme.palette.mode === "dark";
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={{ zIndex: 100010 }}
      PaperProps={{
        sx: {
          borderTopLeftRadius: "24px",
          borderTopRightRadius: "24px",
          padding: "20px 20px 32px",
          backgroundColor: (t) => t.palette.background.default,
          backgroundImage: "none",
          borderTop: dark
            ? "1px solid rgba(255,255,255,0.06)"
            : "1px solid rgba(0,0,0,0.06)",
        },
      }}
    >
      <Box
        sx={{
          width: "40px",
          height: "4px",
          borderRadius: "2px",
          backgroundColor: dark
            ? "rgba(255,255,255,0.15)"
            : "rgba(0,0,0,0.15)",
          margin: "-8px auto 12px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: 700 }}>
          {t("qr.your_code")}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <Icon icon="solar:close-circle-bold" width={22} height={22} />
        </IconButton>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "16px",
        }}
      >
        <QRCodeSVG
          value={link}
          size={220}
          bgColor="#ffffff"
          fgColor="#000000"
          level="Q"
          includeMargin={false}
        />
      </Box>

      <Typography
        sx={{
          textAlign: "center",
          marginTop: "16px",
          fontSize: "13px",
          opacity: 0.6,
        }}
      >
        {t("qr.scan_hint")}
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          marginTop: "6px",
          fontSize: "14px",
          fontWeight: 600,
          letterSpacing: "1px",
        }}
      >
        {code}
      </Typography>
    </Drawer>
  );
}
